import { useAppDispatch, useAppSelector } from 'store/hooks'
import { Profile } from 'store/api/profiles/profiles.interface'
import { useGetProfilesQuery } from 'store/api/profiles'
import { setCurrentProfileId } from 'store/multiprofile/profiles'

export default function useGetSelectedProfile(profileId?: string): Profile | undefined {
  const dispatch = useAppDispatch()
  const sessionToken = useAppSelector(s => s.session.sessionToken)
  let currentProfileId = useAppSelector(s => s.profiles.currentProfileId)
  const selectedProfileId = useAppSelector(s => s.analytics.selectedProfileId)

  const { data: profilesData } = useGetProfilesQuery('', { skip: !sessionToken })

  // if the current profile id exists in the URL, set it as the current profile id
  if (profileId && profileId !== currentProfileId) {
    currentProfileId = profileId
    dispatch(setCurrentProfileId(profileId))
  }

  return profilesData?.profiles.find(p => p.PK === (currentProfileId || selectedProfileId))
}
